import { useScrollReveal } from '../../../hooks/useScrollReveal';

const solutions = [
  {
    number: '01',
    title: 'Gestão de Redes Sociais',
    subtitle: 'Diagnóstico, Execução & Análise',
    description:
      'Mais do que publicações, construímos autoridade. Partimos de um diagnóstico profundo de sua marca para desenhar uma estratégia editorial precisa. Cada ação é guiada por análises que revelam o que funciona, eliminam o que não convertem e amplificam o que transformam seguidores em defensores de sua marca.',
    icon: 'ri-bar-chart-grouped-line',
    image: 'https://public.readdy.ai/ai/img_res/edited_06e97f140b3f26ee3aa5805cb8a1b57e_3c3f49d1.jpg',
  },
  {
    number: '02',
    title: 'Pulso Estratégico',
    subtitle: 'Gestão de Tráfego & Performance',
    description:
      'Conectamos sua essência às pessoas certas. Anúncios precisos que geram resultados reais, com a agilidade que o novo mundo exige.',
    icon: 'ri-line-chart-line',
    image:
      'https://public.readdy.ai/ai/img_res/2de9f10b9c2035a654dc8ce21977023b.jpg',
  },
  {
    number: '03',
    title: 'Conexão Humana',
    subtitle: 'Estratégia de Conteúdo & Social',
    description:
      'Humanizamos sua tecnologia. Criamos diálogos que geram autoridade e transformam seguidores em comunidade.',
    icon: 'ri-team-line',
    image:
      'https://readdy.ai/api/search-image?query=Social%20media%20content%20strategy%20with%20human%20connections%20and%20community%20engagement%2C%20purple%20amethyst%20social%20network%20visualization%2C%20modern%20digital%20communication%20concept%2C%20luxury%20tech%20aesthetic%2C%20professional%20content%20creation%20workspace%2C%20clean%20minimalist%20design%20with%20graphite%20and%20purple%20accents&width=800&height=600&seq=solution-03&orientation=landscape',
  },
];

function SolutionItem({ solution, index }: { solution: typeof solutions[0]; index: number }) {
  const { ref, isVisible } = useScrollReveal(0.1);
  const isEven = index % 2 === 0;

  return (
    <div
      ref={ref}
      className={`flex flex-col ${
        isEven ? 'lg:flex-row' : 'lg:flex-row-reverse'
      } gap-12 items-center transition-all ease-out ${
        isVisible ? 'opacity-100 translate-x-0' : isEven ? 'opacity-0 -translate-x-16' : 'opacity-0 translate-x-16'
      }`}
      style={{ transitionDuration: '800ms', transitionTimingFunction: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)' }}
    >
      <div className="flex-1">
        <div
          className={`relative w-full h-96 rounded-2xl overflow-hidden shadow-2xl transition-all ease-out ${
            isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
          }`}
          style={{
            transitionDuration: '900ms',
            transitionDelay: '150ms',
            transitionTimingFunction: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
          }}
        >
          <img
            src={solution.image}
            alt={solution.title}
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>

      <div
        className={`flex-1 transition-all ease-out ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
        style={{
          transitionDuration: '800ms',
          transitionDelay: '200ms',
          transitionTimingFunction: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
        }}
      >
        <div className="flex items-center gap-4 mb-6">
          <span className="text-6xl font-extralight text-purple-600/20">{solution.number}</span>
          <div className="w-16 h-16 flex items-center justify-center rounded-full bg-purple-100">
            <i className={`${solution.icon} text-3xl text-purple-600`}></i>
          </div>
        </div>

        <h3 className="text-3xl md:text-4xl font-light text-gray-900 mb-2">{solution.title}</h3>
        <p className="text-lg text-purple-600 font-light mb-6">{solution.subtitle}</p>
        <p className="text-lg text-gray-600 font-light leading-relaxed">{solution.description}</p>
      </div>
    </div>
  );
}

export default function Solutions() {
  const { ref: titleRef, isVisible: titleVisible } = useScrollReveal(0.1);

  return (
    <section id="solutions" className="py-32 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">

        <div
          ref={titleRef}
          className={`text-center mb-20 transition-all ease-out ${
            titleVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
          style={{ transitionDuration: '700ms' }}
        >
          <h2 className="text-4xl md:text-5xl font-extralight text-gray-900 mb-6">
            Nossas <span className="font-light text-purple-600">Soluções</span>
          </h2>
          <div className="w-20 h-0.5 bg-purple-600 mx-auto"></div>
        </div>

        <div className="space-y-24">
          {solutions.map((solution, index) => (
            <SolutionItem key={index} solution={solution} index={index} />
          ))}
        </div>

      </div>
    </section>
  );
}
